import { FORM_TYPES, MODAL_TYPES, TRIAL_TYPES } from '../consts';
import { getFlowType } from './getFlowType';

export const getExperimentVersion = () => {
  const { isLoggedIn, trialType } = window.LPFormData;
  const modalType = window.TrialForm?.modalType;
  const params = new URLSearchParams(window.location.search);
  const freePremium = params.get('experiment_version') === 'TPR5_sitecore_free_premium';
  const hasFreePath = window.location.pathname.includes('/free');

  if (modalType === MODAL_TYPES.UNIFIED) return 'Unified_Trial';
  if (modalType === MODAL_TYPES.CHEVY && window.trialModifier) return '2Step_Modal_Premium';
  if (modalType === MODAL_TYPES.CHEVY) return '2Step_Modal';
  if (trialType === TRIAL_TYPES.PREMIUM && freePremium) return 'TPR5_sitecore_free_premium';
  if (trialType === TRIAL_TYPES.PREMIUM && hasFreePath) return 'TPR5_sitecore_free_free';
  if (trialType === TRIAL_TYPES.PREMIUM) return 'TPR5_sitecore_premium';
  if (trialType === TRIAL_TYPES.FAMILIES) return 'TPR_Phase6';
  if (trialType === TRIAL_TYPES.MSP) return 'TPR_MSP_phase1';
  if (trialType === TRIAL_TYPES.TEAMS) return 'TPR_Phase4_teams';
  if (isLoggedIn) return 'TPR_Phase2';
  return 'TPR_Phase1';
};

export const getEventName = (legacy?: boolean) => {
  const { trialType } = window.LPFormData;
  const modalType = window.TrialForm?.modalType;

  if (modalType === MODAL_TYPES.UNIFIED) return MODAL_TYPES.UNIFIED;
  if (trialType === TRIAL_TYPES.PREMIUM) return TRIAL_TYPES.PREMIUM;
  if (trialType === TRIAL_TYPES.FAMILIES) return TRIAL_TYPES.FAMILIES;
  if (trialType === TRIAL_TYPES.MSP) return TRIAL_TYPES.MSP;
  if (trialType === TRIAL_TYPES.TEAMS) return TRIAL_TYPES.TEAMS;
  return legacy ? TRIAL_TYPES.ENTERPRISE : TRIAL_TYPES.BUSINESS;
};

export const getEventReason = () => {
  const params = new URLSearchParams(window.location.search);
  let isMax = params.has('max');

  const { formType, trialType } = window.LPFormData;
  const flowType = getFlowType(formType);

  if (flowType === FORM_TYPES.PURCHASE) {
    return isMax
      ? 'businessmax_direct_buy'
      : trialType === TRIAL_TYPES.PREMIUM
        ? `premium_direct_buy`
        : `${getEventName()}_buy_start`;
  } else {
    return isMax ? 'businessmax' : `${getEventName()}_trial_start`;
  }
};

export const getUserCheckEndpoint = () => {
  const { trialType } = window.LPFormData;

  if (trialType === TRIAL_TYPES.MSP) return 'MspEmailCheck';
  if (trialType === TRIAL_TYPES.TEAMS) return 'TeamsEmailCheck';
  if (trialType === TRIAL_TYPES.PREMIUM) return 'PremiumEmailCheck';
  if (trialType === TRIAL_TYPES.FAMILIES) return 'FamiliesEmailCheck';
  return 'EmailCheckBusinessUser';
};
